import React from 'react';
import { BureauLogo } from '../ui/BureauLogo';

export const IMPORT_REPORT_BUREAUS = ['transunion', 'experian', 'equifax'];

/**
 * Shared three-bureau marks for the Self Repair Import Report experience.
 * Uses the project bureau SVG assets once; do not embed duplicate copies.
 */
export default function ImportReportBureauLogos({
  isDark = false,
  className = '',
  height = '1.35rem',
  maxWidth = '110px',
}) {
  return (
    <div
      className={`flex flex-wrap items-center justify-center gap-4 sm:gap-6 ${className}`}
      data-testid="import-report-bureau-logos"
    >
      {IMPORT_REPORT_BUREAUS.map((bureau) => (
        <span
          key={bureau}
          className="inline-flex items-center"
          data-testid={`import-report-bureau-logo-${bureau}`}
        >
          <BureauLogo
            bureau={bureau}
            isDark={isDark}
            height={height}
            maxWidth={maxWidth}
          />
        </span>
      ))}
    </div>
  );
}
